import { jsx as _jsx } from "react/jsx-runtime";
/* from https://codesandbox.io/s/colored-tabs-material-ui-237l7?file=/demo.tsx:0-5400
 because native Tab demo has problem with type number vs string on tabValue
*/
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
export function TabPanel(props) {
    const { children, value, index, unmountOnBlur, ...other } = props;
    if (unmountOnBlur !== true) {
        return (_jsx(Typography, { component: "div", role: "tabpanel", hidden: value !== index, id: `vertical-tabpanel-${index}`, "aria-labelledby": `vertical-tab-${index}`, ...other, children: _jsx(Box, { children: children }) }));
    }
    else {
        if (value === index) {
            return (_jsx(Typography, { component: "div", role: "tabpanel", id: `vertical-tabpanel-${index}`, "aria-labelledby": `vertical-tab-${index}`, ...other, children: _jsx(Box, { children: children }) }));
        }
        else {
            return null;
        }
    }
}
